import SectionHeading from "@/components/base/SectionHeading";
import { trustHighlights } from "@/mocks/site";
import { galleryItems } from "@/data/gallery";

const panelImages = [galleryItems[2], galleryItems[7], galleryItems[3]];

const badges = [
  "bg-primary-500 text-background-50",
  "bg-secondary-500 text-background-50",
  "bg-accent-500 text-background-50",
];

/**
 * "Care philosophy" panels — each principle paired with a real photograph
 * from the clinic and a colour-coded badge.
 */
export default function CarePhilosophy() {
  return (
    <section className="bg-gradient-to-b from-background-50 to-secondary-50/50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Our Approach"
          title="Care principles that guide every consultation"
          description="We focus on understanding your condition fully and choosing the least invasive treatment that works — with a clear plan you can follow."
        />

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {trustHighlights.map((item, index) => {
            const image = panelImages[index];
            return (
              <article
                key={item.title}
                className="reveal group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_30px_60px_-40px_rgba(15,40,80,0.55)]"
              >
                <div className="relative h-52 w-full overflow-hidden">
                  <img
                    src={image.image}
                    alt={image.alt}
                    title={`${image.title} — Ortho Spine Care, Trichy`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div
                    className="absolute inset-0 bg-gradient-to-t from-primary-950/50 to-transparent"
                    aria-hidden="true"
                  ></div>
                  <span
                    className={`absolute bottom-4 left-4 flex h-11 w-11 items-center justify-center rounded-xl shadow-lg ${
                      badges[index % badges.length]
                    }`}
                  >
                    <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}